<template>
    <div
        class="app-tab-container"
        :class="{
            'official-joined': $root.officialJoinedStyle,
        }"
        :style="{
            backgroundColor: $root.officialBackgroundColor,
        }"
    >
        <div ref="tab" class="tab-wrapper scroll-x">
            <div
                v-for="(tab, index) of tabs"
                :key="index"
                :class="['tab-item', $root.tabIndex === index ? 'tab-item-focus' : '']"
                :style="{
                    color: $root.tabIndex === index ?
                        $root.officialHighLightFontColor : $root.officialNormalFontColor,
                }"
                @click="changeTab(index)"
            >
                <span>{{ tab }}</span>
                <div
                    v-if="$root.tabIndex === index" class="tab-item-line"
                    :style="{
                        borderColor: $root.officialHighLightFontColor,
                    }"
                >
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        tabs: {
            type: Array,
            required: true,
        },
    },
    computed: {
        tabIndex: function () {
            return this.$root.tabIndex;
        },
    },
    watch: {
        tabIndex(val) {
            if (val > 3) {
                this.$refs.tab.scrollTo(999, 0);
            }
        },
    },
    methods: {
        changeTab(index) {
            this.$root.tabIndex = index;
            document.body.scrollIntoView();
            this.doClickLog(index);
            this.$emit('onTabChange');
        },
        doClickLog(index) {
            let value = '';
            switch (this.$root.tabs[index]) {
                case '详情':
                    value = 'detailTab';
                    break;
                case '动态':
                    value = 'officalTab';
                    break;
                case '评价':
                    value = 'commentTab';
                    break;
                case '问答':
                    value = 'answerList';
                    break;
                case '视频':
                    value = 'videoTab';
                    break;
                case '贴吧':
                    value = 'tiebaTab';
                    break;
                case '攻略':
                    value = 'strategyTab';
                    break;
                case '资讯':
                    value = 'articleTab';
                    break;
                case '图集':
                    value = 'picsTab';
            }
            let content = {
                value: value,
                page: value,
                ext: {
                    id: '',
                    ext: Object.assign(this.$root.extData, {}),
                    pos: '',
                },
            };
            this.$logger.click(content);
        },
    },
};

</script>

<style lang="scss">
    @import "~@/common/style/mixin/utils";
    $design-width: 1242;

    .app-tab-container {
        font-size: px2rem(51);
        width: px2rem(1242);
        border-bottom: 1px solid #E6E6E6;
        background-color: #fff;
        &.official-joined {
            border-bottom: none;
            color: #FFF;
        }
        .tab-wrapper {
            height: px2rem(120);
            display: flex;
            align-items: center;
            padding: 0 0 0 px2rem(31);
            .tab-item {
                flex: 1 0 18.30%;
                line-height: px2rem(120);
                text-align: center;
                position: relative;
                &-focus {
                    color: #38F;
                    font-weight: bold;
                }
                .tab-item-line {
                    position: absolute;
                    bottom: 0;
                    left: 50%;
                    margin-left: px2rem(-30);
                    width: px2rem(60);
                    border-bottom: px2rem(6) solid #38F;
                }
                span {
                    position: relative;
                }
            }
        }
    }
</style>